import PropTypes from "prop-types";
import { MessageCircle } from "lucide-react";

const Chat = ({ chatAvailable, organization }) => {
  const onClick = (e) => {
    e.preventDefault();
    const { flags, links } = organization;
    if (flags?.enableChat && chatAvailable && links?.chat) {
      if (flags.newChat) {
        window.launchChatByOpenEntryPoint();
      } else {
        window.open(
          links.chat,
          "211 Chat",
          "'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,top=200,left=500,width=500,height=650'"
        );
      }
    }
  };

  return (
    <a className="utility-link" onClick={onClick}>
      <MessageCircle aria-hidden="true" size={16} strokeWidth={2} style={{ marginRight: "4px" }} />
      {organization.flags &&
      organization.flags.enableChat &&
      chatAvailable &&
      organization.links &&
      organization.links.chat ? (
        <span className="chat-status">Chat With Us</span>
      ) : (
        <span className="chat-status">Chat Unavailable</span>
      )}
    </a>
  );
};

Chat.propTypes = {
  chatAvailable: PropTypes.bool,
  organization: PropTypes.object,
};

export default Chat;
